module.exports = __webpack_public_path__ + "img/122.7de53218.jpg";